import React from 'react';
import partnerVideo from '../img/envision/communication/3129540-uhd_3840_2160_30fps.mp4'; // Replace with the correct path to your video file

const CommunicationBanner = () => {
    return (
        <div style={{ position: 'relative', height: '750px', width: '100%' }}>
            {/* Text Overlay */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1,
                   flexDirection: 'column',
                }}
            >
                <h1 style={{ margin: 0, textAlign: 'center', fontSize:'26px' }}>Transforming the Communication Industry with next-generation security,<br></br> seamless connectivity, and resilient digital infrastructure</h1>
                {/* <p>Enabling Network Transformation and Empowering Autonosmous Operations</p> */}
            </div>

            {/* Video */}
            <video
                src={partnerVideo}
                alt="partner video"
                autoPlay
                loop
                muted
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    objectFit: 'cover', // This will ensure the video covers the area without stretching
                }}
            />
        </div>
    );
};

export default CommunicationBanner;
